module.exports = __webpack_public_path__ + "static/img/home_11_3.966c570.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homePage_new/home_11_3.png
// module id = mE6Z
// module chunks = 3 64